import { render, staticRenderFns } from "./baoming.vue?vue&type=template&id=06411780&scoped=true"
import script from "./baoming.vue?vue&type=script&lang=js"
export * from "./baoming.vue?vue&type=script&lang=js"
import style0 from "./baoming.vue?vue&type=style&index=0&id=06411780&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06411780",
  null
  
)

export default component.exports